"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowseAbandonmentListener_1 = require("../listeners/BrowseAbandonmentListener");
var MobileIdentityService_1 = __importDefault(require("../services/MobileIdentityService"));
var network_1 = __importDefault(require("../services/network"));
var Tracker_1 = __importDefault(require("../services/tracking/Tracker"));
var CampaignManager_1 = require("./CampaignManager");
var GrowCore_1 = require("./GrowCore");
var GrowCoreFactory = /** @class */ (function () {
    function GrowCoreFactory() {
    }
    GrowCoreFactory.buildGrowCore = function (user, script, services, logger, sessionManager) {
        var apis = (0, network_1.default)(logger, services.localStorage);
        var mobileIdentityService = new MobileIdentityService_1.default({
            user: user,
            sessionManager: sessionManager,
            localStorage: services.localStorage,
            logger: logger,
            api: apis.trackingApi,
            browserEnvironment: services.browserEnvironment
        });
        var tracker = new Tracker_1.default({
            environment: services.browserEnvironment,
            logger: logger,
            network: apis.trackingApi,
            storage: services.localStorage,
            sessionManager: sessionManager,
            userID: user.id
        });
        var campaignManager = new CampaignManager_1.CampaignManager({
            services: services,
            logger: logger,
            currentScript: script,
            sessionManager: sessionManager,
            tracker: tracker,
            userID: user.id,
            api: apis.authApi
        });
        if (user.browseAbandonment) {
            (0, BrowseAbandonmentListener_1.registerBrowseAbandonmentListener)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
            (0, BrowseAbandonmentListener_1.handlePageChange)({
                api: apis.trackingApi,
                browseAbandonmentRules: user.browseAbandonment,
                environment: services.browserEnvironment,
                localStorage: services.localStorage,
                logger: logger,
                sessionManager: sessionManager,
                userID: user.id
            });
        }
        return new GrowCore_1.GrowCore({
            apis: apis,
            browserEnvironment: services.browserEnvironment,
            campaignManager: campaignManager,
            localStorage: services.localStorage,
            logger: logger,
            mobileIdentityService: mobileIdentityService,
            sessionManager: sessionManager,
            user: user,
            visitorIdentificationService: services.visitorIdentificationService
        });
    };
    return GrowCoreFactory;
}());
exports.default = GrowCoreFactory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9jb3JlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQ0Esb0ZBQTRHO0FBRzVHLDRGQUFxRTtBQUVyRSxnRUFBOEM7QUFDOUMseUVBQWtEO0FBQ2xELHFEQUFtRDtBQUNuRCx1Q0FBcUM7QUFFckM7SUFBQTtJQXVFQSxDQUFDO0lBdEVpQiw2QkFBYSxHQUEzQixVQUNJLElBQVUsRUFDVixNQUF5QixFQUN6QixRQUFzQixFQUN0QixNQUFjLEVBQ2QsY0FBOEI7UUFFOUIsSUFBTSxJQUFJLEdBQUcsSUFBQSxpQkFBWSxFQUFDLE1BQU0sRUFBRSxRQUFRLENBQUMsWUFBWSxDQUFDLENBQUE7UUFDeEQsSUFBTSxxQkFBcUIsR0FBRyxJQUFJLCtCQUFxQixDQUFDO1lBQ3BELElBQUksTUFBQTtZQUNKLGNBQWMsZ0JBQUE7WUFDZCxZQUFZLEVBQUUsUUFBUSxDQUFDLFlBQVk7WUFDbkMsTUFBTSxRQUFBO1lBQ04sR0FBRyxFQUFFLElBQUksQ0FBQyxXQUFXO1lBQ3JCLGtCQUFrQixFQUFFLFFBQVEsQ0FBQyxrQkFBa0I7U0FDbEQsQ0FBQyxDQUFBO1FBRUYsSUFBTSxPQUFPLEdBQUcsSUFBSSxpQkFBTyxDQUFDO1lBQ3hCLFdBQVcsRUFBRSxRQUFRLENBQUMsa0JBQWtCO1lBQ3hDLE1BQU0sRUFBRSxNQUFNO1lBQ2QsT0FBTyxFQUFFLElBQUksQ0FBQyxXQUFXO1lBQ3pCLE9BQU8sRUFBRSxRQUFRLENBQUMsWUFBWTtZQUM5QixjQUFjLEVBQUUsY0FBYztZQUM5QixNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7U0FDbEIsQ0FBQyxDQUFBO1FBRUYsSUFBTSxlQUFlLEdBQUcsSUFBSSxpQ0FBZSxDQUFDO1lBQ3hDLFFBQVEsVUFBQTtZQUNSLE1BQU0sUUFBQTtZQUNOLGFBQWEsRUFBRSxNQUFNO1lBQ3JCLGNBQWMsZ0JBQUE7WUFDZCxPQUFPLFNBQUE7WUFDUCxNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7WUFDZixHQUFHLEVBQUUsSUFBSSxDQUFDLE9BQU87U0FDcEIsQ0FBQyxDQUFBO1FBRUYsSUFBSSxJQUFJLENBQUMsaUJBQWlCLEVBQUU7WUFDeEIsSUFBQSw2REFBaUMsRUFBQztnQkFDOUIsR0FBRyxFQUFFLElBQUksQ0FBQyxXQUFXO2dCQUNyQixzQkFBc0IsRUFBRSxJQUFJLENBQUMsaUJBQXdEO2dCQUNyRixXQUFXLEVBQUUsUUFBUSxDQUFDLGtCQUFrQjtnQkFDeEMsWUFBWSxFQUFFLFFBQVEsQ0FBQyxZQUFZO2dCQUNuQyxNQUFNLFFBQUE7Z0JBQ04sY0FBYyxnQkFBQTtnQkFDZCxNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUU7YUFDbEIsQ0FBQyxDQUFBO1lBRUYsSUFBQSw0Q0FBZ0IsRUFBQztnQkFDYixHQUFHLEVBQUUsSUFBSSxDQUFDLFdBQVc7Z0JBQ3JCLHNCQUFzQixFQUFFLElBQUksQ0FBQyxpQkFBd0Q7Z0JBQ3JGLFdBQVcsRUFBRSxRQUFRLENBQUMsa0JBQWtCO2dCQUN4QyxZQUFZLEVBQUUsUUFBUSxDQUFDLFlBQVk7Z0JBQ25DLE1BQU0sUUFBQTtnQkFDTixjQUFjLGdCQUFBO2dCQUNkLE1BQU0sRUFBRSxJQUFJLENBQUMsRUFBRTthQUNsQixDQUFDLENBQUE7U0FDTDtRQUVELE9BQU8sSUFBSSxtQkFBUSxDQUFDO1lBQ2hCLElBQUksTUFBQTtZQUNKLGtCQUFrQixFQUFFLFFBQVEsQ0FBQyxrQkFBa0I7WUFDL0MsZUFBZSxpQkFBQTtZQUNmLFlBQVksRUFBRSxRQUFRLENBQUMsWUFBWTtZQUNuQyxNQUFNLFFBQUE7WUFDTixxQkFBcUIsdUJBQUE7WUFDckIsY0FBYyxnQkFBQTtZQUNkLElBQUksTUFBQTtZQUNKLDRCQUE0QixFQUFFLFFBQVEsQ0FBQyw0QkFBNEI7U0FDdEUsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUNMLHNCQUFDO0FBQUQsQ0FBQyxBQXZFRCxJQXVFQyJ9